import Axios from "axios";
import KnockOut from "knockout";
import KnockOutMapping from "knockout-mapping";

import DataHelper from "@Scripts/Common/DataHelper";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class ProductDetailViewModel {
    constructor() {
        let self: any = this;

        self.isDataFetched = KnockOut.observable(false);
        self.isPurchaseDisabled = KnockOut.observable(false);
        self.quantity = KnockOut.observable(1);
        self.selectedVariant = KnockOut.observable();

        self.shippingDestinations = KnockOut.observableArray();
        self.selectedShippingDestination = KnockOut.observable();
        self.minimumOrderTotal = KnockOut.observable();
        self.freeShippingTableTotal = KnockOut.observable();
        self.firstShippingCostThreshold = KnockOut.observable();
        self.secondShippingCostThreshold = KnockOut.observable();

        self.selectedVariantCheckBox = KnockOut.observable();
        self.selectedVariantCheckBox.subscribe(function (newVal: any) {
            self.selectedVariant(self.variants().find(x => x.code() === newVal));
        });

        self.addQuantity = function () {
            if (!isNaN(parseInt(self.quantity(), 10))) {
                self.quantity(parseInt(self.quantity(), 10) + 1);
            } else {
                self.quantity(1);
            }

            if (self.quantity() > 20) {
                self.quantity(20);
            }
        };

        self.removeQuantity = function () {
            if (!isNaN(parseInt(self.quantity(), 10))) {
                self.quantity(parseInt(self.quantity(), 10) - 1);
            } else {
                self.quantity(1);
            }

            if (self.quantity() < 1) {
                self.quantity(1);
            }
        };

        self.addProductToCart = async function () {
            var $context = $(".salepanel");

            $(".validation").hide();
            FormHelper.resetValidation($context);
            FormHelper.disableControls($context);

            try {
                let cartDetail = (await Axios.post((<any>window).App.routes.Cart_AddProduct, { productcode: (<any>window).App.bag.productCode, variantcode: getVariantCode(), quantity: self.quantity() }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

                (<any>window).App.viewModels.cartPreview.update(cartDetail.cartInfo);
                (<any>window).App.viewModels.cartPreview.animate();

                GTagHelper.sendEvent("add_to_cart", {
                    currency: "EUR",
                    value: parseFloat((<any>window).App.bag.product.price.replace(/\./g, "").replace(",", ".")) * self.quantity(),
                    items: [
                        {
                            item_id: (<any>window).App.bag.product.code,
                            item_name: (<any>window).App.bag.product.title,
                            affiliation: "IloveOstrica",
                            item_category: (<any>window).App.bag.product.categoryName,
                            price: (<any>window).App.bag.product.price.replace(/\./g, "").replace(",", "."),
                            quantity: self.quantity()
                        }
                    ]
                });

                (<any>window).window.window.dataLayer = (<any>window).window.window.dataLayer || [];
                (<any>window).window.dataLayer.push({ ecommerce: null });
                (<any>window).window.dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        currency: "EUR",
                        value: parseFloat((<any>window).App.bag.product.price.replace(/\./g, "").replace(",", ".")) * self.quantity(),
                        items: [
                            {
                                item_id: (<any>window).App.bag.product.code,
                                item_name: (<any>window).App.bag.product.title,
                                affiliation: "IloveOstrica",
                                item_category: (<any>window).App.bag.product.categoryName,
                                currency: "EUR",
                                price: (<any>window).App.bag.product.price.replace(/\./g, "").replace(",", "."),
                                quantity: self.quantity()
                            }
                        ]
                    }
                });

                if ((<any>window).fbq) {
                    var contentType = "product",
                        contentIDs = [],
                        contents = [],
                        currency = "EUR",
                        value = parseFloat((<any>window).App.bag.product.price.split(',').join('.')) * self.quantity();

                    contentIDs.push((<any>window).App.bag.product.code);
                    contents.push({ id: (<any>window).App.bag.product.code, quantity: self.quantity(), item_price: (<any>window).App.bag.product.price.split(',').join('.') });

                    (<any>window).fbq("track", "AddToCart", { content_type: contentType, content_ids: contentIDs, contents: contents, currency: currency, value: value });
                }

                if ((<any>window).sendinblue) {
                    var track_event = {
                        "data": {
                            "items": []
                        }
                    };

                    for (var i = 0; i < cartDetail.cartInfo.cartRows.length; i++) {
                        var cartRowInfo = {
                            "ProductName": cartDetail.cartInfo.cartRows[i].productName,
                            "ProductImageUrl": "/it/media/product/images/150-150-fix/" + cartDetail.cartInfo.cartRows[i].productImageCode,
                            "Quantity": cartDetail.cartInfo.cartRows[i].quantity,
                            "VariantCode": cartDetail.cartInfo.cartRows[i].variantCode,
                            "VariantName": cartDetail.cartInfo.cartRows[i].variantDescription,
                            "UnitPrice": cartDetail.cartInfo.cartRows[i].unitPrice,
                            "TotalPrice": cartDetail.cartInfo.cartRows[i].rowPrice
                        };
                        track_event.data.items.push(cartRowInfo);
                    }

                    (<any>window).sendinblue.track("Click_Aggiunta_Carrello", { "Category": (<any>window).App.bag.product.categoryName }, track_event);
                }

                self.quantity(1);

            } catch (error) {
                if (error.response.status === 400) {
                    FormHelper.setValidation($context, error.response.data);
                    $(".validation").show();
                }
            }
        };

        self.getVariantPrice = function (price: any) {
            let dataHelperConfiguration = DataHelper.getConfigurationByCulture("it-IT");
            return DataHelper.convertToString(price(), "Decimal", dataHelperConfiguration);
        };

        function getVariantCode() {
            return self.selectedVariant().code();
        }

        async function init() {
            let productInfo = (await Axios.post((<any>window).App.routes.Catalogue_GetProductInfo, { productCode: (<any>window).App.bag.productCode })).data;

            KnockOutMapping.fromJS(productInfo, {}, self);
            self.isDataFetched(true);
            self.isPurchaseDisabled(productInfo.product.isPurchaseDisabled);
            self.selectedVariantCheckBox(productInfo.variants[0]?.code);

            if ((<any>window).ga) {
                // Analytics: Product view
                (<any>window).ga("ec:addProduct", {
                    "id": (<any>window).App.bag.product.code,
                    "name": (<any>window).App.bag.product.title,
                    "brand": "IloveOstrica",
                    "category": (<any>window).App.bag.product.categoryName,
                    "price": (<any>window).App.bag.product.price
                });
                (<any>window).ga("ec:setAction", "detail");
                (<any>window).ga("send", "event", {
                    eventCategory: "Ecommerce",
                    eventAction: "View",
                    eventLabel: (<any>window).App.bag.product.title
                });
            }

            if (productInfo.variants.length !== 0) {
                if ((<any>window).fbq) {
                    var contentType = "product",
                        contentName = $(".product-detail").data("productname"),
                        contentIDs = [],
                        contents = [],
                        currency = "EUR",
                        value = parseFloat(self.selectedVariant().price) * self.quantity();

                    contentIDs.push($("#ProductCode").val());
                    contents.push({ id: $("#ProductCode").val(), quantity: self.quantity(), item_price: self.selectedVariant().price });

                    (<any>window).fbq("track", "ViewContent", { content_type: contentType, content_name: contentName, content_ids: contentIDs, contents: contents, currency: currency, value: value });
                }
            }

            const result = (await Axios.post((<any>window).App.routes.Cart_GetShippingDestinations, null)).data;
            self.shippingDestinations(result.shippingDestinations);
            self.minimumOrderTotal(result.minimumOrderTotal);
            self.freeShippingTableTotal(result.freeShippingTotal);
            self.firstShippingCostThreshold(result.firstShippingCostThreshold);
            self.secondShippingCostThreshold(result.secondShippingCostThreshold);
        }

        init();
    }
}